import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    {
        path: 'datos-basicos',
        loadChildren: () => import('./main/datos-basicos/datos-basicos.module').then(m => m.DatosBasicosModule)
    },
    {
        path: 'archivo',
        loadChildren: () => import('./main/inventario/inventario.module').then(m => m.InventarioModule)
    },
    {
        path      : '**',
        redirectTo: 'home'
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
